// Personnel slider — vanilla scroll-snap with prev/next chevron controls.
// Content is server-rendered in Razor; this script only adds button behavior
// (scrollBy on click), mouse drag-to-scroll on desktop, and toggles the
// disabled state of the chevrons based on the track's scroll position.
// Native scroll-snap handles touch swipe — the drag handlers below skip
// pointerType === 'touch' so they don't fight the browser's own scroll.
(function () {
    'use strict';

    function init(block) {
        var track = block.querySelector('[data-personnel-slider-track]');
        var prevBtn = block.querySelector('[data-personnel-slider-prev]');
        var nextBtn = block.querySelector('[data-personnel-slider-next]');
        if (!track || !prevBtn || !nextBtn) {
            return;
        }

        function step() {
            var first = track.querySelector('.block-personnel-slider__card');
            if (!first) {
                return track.clientWidth;
            }
            var styles = window.getComputedStyle(track);
            var gap = parseFloat(styles.columnGap || styles.gap) || 0;
            return first.offsetWidth + gap;
        }

        function update() {
            var max = track.scrollWidth - track.clientWidth;
            prevBtn.disabled = track.scrollLeft <= 1;
            nextBtn.disabled = track.scrollLeft >= max - 1;
        }

        prevBtn.addEventListener('click', function () {
            track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
        nextBtn.addEventListener('click', function () {
            track.scrollBy({ left: step(), behavior: 'smooth' });
        });
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        // Defer first update to next frame so layout has settled —
        // prevents a brief enabled→disabled flicker when the block
        // mounts inside a container that's still being sized.
        requestAnimationFrame(update);

        // Mouse drag-to-scroll. Touch is intentionally skipped so the
        // browser's native scroll-snap keeps owning swipe gestures —
        // taking pointer capture on touch would suppress that.
        var isDragging = false;
        var startX = 0;
        var startScrollLeft = 0;

        track.addEventListener('pointerdown', function (e) {
            if (e.pointerType === 'touch') return;
            // preventDefault stops the browser's native image-drag and text
            // selection that would otherwise fire on mousedown over an <img>.
            e.preventDefault();
            isDragging = true;
            startX = e.clientX;
            startScrollLeft = track.scrollLeft;
            track.setPointerCapture(e.pointerId);
            track.style.cursor = 'grabbing';
        });

        track.addEventListener('pointermove', function (e) {
            if (!isDragging) return;
            track.scrollLeft = startScrollLeft - (e.clientX - startX);
        });

        function endDrag(e) {
            if (!isDragging) return;
            isDragging = false;
            try { track.releasePointerCapture(e.pointerId); } catch (_) { /* already released */ }
            track.style.cursor = '';
        }

        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);
    }

    function ready() {
        document.querySelectorAll('.block-personnel-slider').forEach(init);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', ready);
    } else {
        ready();
    }
})();
